const toggleScrollBtnTop = () => {
    const scrollToTopBtn = window.document.querySelector('.js-scrollToTopBtn');
    const actionType = document.body.scrollTop > 200 || document.documentElement.scrollTop > 200 ? 'add' : 'remove';
    if (!scrollToTopBtn)
        return;
    scrollToTopBtn.classList[actionType]('active');
};
export default toggleScrollBtnTop;
